// @ts-nocheck

import React, { useState, useRef } from "react";
import { BASE_URL } from "../env";
import axios from "axios";
import { CSVLink } from "react-csv";
import { CSVReader } from "react-papaparse";
import QuestionCSV from "../Assets/img/QuestionCSV.png";
import { Store } from "react-notifications-component";
// const buttonRef = React.createRef();
const QuizQuestionForm = () => {
	const buttonRef = useRef<CSVReader>(null);
	const [question, setquestion] = useState("");
	const [questionType, setquestiontype] = useState("");
	const [questionPic, setquestionpic] = useState("");
	const [answerSelectionType, setanswerselectiontype] = useState("");
	const [ansArr, setansArr] = useState([""]);
	const [correctAnswer, setcorrectanswer] = useState("");
	const [msgforcorrectans, setmsgforcorrectans] = useState("");
	const [msgforincorrectans, setmsgforincorrectans] = useState("");
	const [explanation, setexplanation] = useState("");
	const [point, setpoint] = useState("");
	const [timer, settimer] = useState("");
	const [submitted_no, setsubmitted_no] = useState("");
	const [company, setcompany] = useState("");
	const [avgtosolve, setavgtosolve] = useState("");
	const [topic, settopic] = useState("");
	const [answer, setans] = useState("");
	const [ansImage, setAnsImage] = useState([]);
	const [isImageAns, setIsImageAns] = useState(false);
	const [isTextAns, setIsTextAns] = useState(false);
	const [uploaded, setUploaded] = useState(false);
	const [uploadedImages, setUploadedImages] = useState([]);
	const [CSVdata, setCSVdata] = useState<any[]>([]);
	const [csvData, setCsvData] = useState([]);
	const [quesImage, setQuesImage] = useState(null);

	const handleOpenDialog = (e: any) => {
		// Note that the ref is set async, so it might be null at some point
		if (buttonRef.current) {
			buttonRef.current.open(e);
		}
	};

	async function AddQuestion(data: any, position: number) {
		const finalJSON = {
			answers: data[0].trim().split("~,~"),
			question: data[1],
			questionType: data[2],
			questionPic: data[3],
			answerSelectionType: data[4],
			correctAnswer: data[5].trim().split("~,~"),
			messageForCorrectAnswer: data[6],
			messageForIncorrectAnswer: data[7],
			explanation: data[8],
			timer: data[9],
			marks: parseInt(data[10]),
			topic: data[11],
			point: "1",
		};
		const notifyPopup = () => {
			Store.addNotification({
				title: "Success!",
				message: "Form Submitted Successfully!",
				type: "success",
				insert: "bottom",
				container: "bottom-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 3000,
					onScreen: true,
				},
			});
		};
		if (
			!finalJSON.answers.includes(finalJSON.correctAnswer[0]) ||
			isNaN(finalJSON.marks)
		) {
			console.log(
				finalJSON.answers,
				finalJSON.correctAnswer,
				finalJSON.marks
			);
			setCsvData((prev) => {
				let temp = JSON.parse(JSON.stringify(prev));

				temp.push({
					answers: data[0],
					question: data[1],
					questionType: data[2],
					questionPic: data[3],
					answerSelectionType: data[4],
					correctAnswer: data[5],
					messageForCorrectAnswer: data[6],
					messageForIncorrectAnswer: data[7],
					explanation: data[8],
					timer: data[9],
					point: data[10],
					topic: data[11],
				});
				return temp;
			});

			return;
		}
		await fetch(BASE_URL + "/createQuestionSchema/", {
			method: "POST",
			headers: {
				"Content-Type": "Application/json",
			},
			body: JSON.stringify(finalJSON),
		})
			.then((res) => res.json())
			.then((data) => {
				notifyPopup();
				setquestion("");
				setquestiontype("");
				setquestionpic("");
				setanswerselectiontype("");
				setansArr([]);
				setcorrectanswer("");
				setmsgforcorrectans("");
				setmsgforincorrectans("");
				setexplanation("");
				setpoint("");
				settimer("");
				setsubmitted_no("");
				setcompany("");
				setavgtosolve("");
				settopic("");
				setans("");
				setAnsImage([]);
				setIsImageAns(false);
				setIsTextAns(false);
				setUploaded(false);
				setUploadedImages([]);
				setCSVdata([]);
			})
			.catch((err) => console.log(err));
	}

	async function InterMediateAddQuestion() {
		for (var i = 1; i < CSVdata.length; i++) {
			var data = CSVdata[i].data;
			await AddQuestion(data, i);
		}

		alert("Questions Uploaded Successfuly");
	}

	const handleOnFileLoad = (data: any) => {
		setCSVdata(data);
	};

	const handleOnError = (err: any) => {
		console.error(err);
	};

	// const handleOnRemoveFile = (data) => { };

	const handleRemoveFile = () => {
		// Note that the ref is set async, so it might be null at some point
		if (buttonRef.current) {
			buttonRef.current.removeFile();
		}
	};

	const QuestionImageUploadHandler = async () => {
		var ImageData = new FormData();
		ImageData.append("answers", quesImage);

		const res = await axios.post(BASE_URL + "/uploadAnsImages", ImageData, {
			headers: { "Content-Type": "application/json" },
		});

		setquestionpic(res.data.message[0] || "");
	};

	const ImageUploadHandler = async () => {
		var ImageData = new FormData();
		ImageData.append("answers", ansImage[0]);
		ImageData.append("answers", ansImage[1]);
		ImageData.append("answers", ansImage[2]);
		ImageData.append("answers", ansImage[3]);
		const res = await axios.post(BASE_URL + "/uploadAnsImages", ImageData, {
			headers: { "Content-Type": "application/json" },
		});
		console.log(res.data.message);
		setUploaded((prev) => !prev);
		setUploadedImages(res.data.message);
	};

	const submitHandler = async () => {
		// var formData = new FormData();

		// formData.append("question", question);
		// formData.append("questionType", questionType);
		// formData.append("questionPic", questionPic);
		// formData.append("correctAnswer", correctAnswer);
		// formData.append("answerSelectionType", answerSelectionType);
		// formData.append("messageForCorrectAnswer", msgforcorrectans);
		// formData.append("messageForIncorrectAnswer", msgforincorrectans);
		// formData.append("explanation", explanation);
		// formData.append("point", point);
		// formData.append("timer", timer);
		// if (isImageAns) {
		// 	formData.append("answers", uploadedImages);
		// }
		// if (isTextAns) {
		// 	formData.append("answers", ansArr);
		// }
		// console.log("answerSelectionType", answerSelectionType);
		fetch(BASE_URL + "/createQuestionSchema/", {
			method: "POST",
			headers: {
				"Content-Type": "Application/json",
			},
			body: JSON.stringify({
				answers: isImageAns ? uploadedImages : ansArr,
				question: question,
				questionType: questionType,
				questionPic: questionPic,
				answerSelectionType: answerSelectionType,
				correctAnswer: correctAnswer,
				messageForCorrectAnswer: msgforcorrectans,
				messageForIncorrectAnswer: msgforincorrectans,
				explanation: explanation,
				point: point,
				timer: timer,
				topic: topic,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success === "true") {
					alert(data.success);
					window.location.reload();
				}
				console.log(data);
			})
			.catch((err) => console.log(err));
	};

	const handleAddFields = () => {
		setansArr((prev) => {
			const return_data = [...new Set([...prev, ""])];
			return return_data;
		});
	};
	const handleRemoveFields = () => {
		setansArr((prev) => {
			let return_data = [...prev];
			return_data.pop();

			return return_data;
		});
	};

	return (
		<div className="mx-auto p-5 form-control quiz-container">
			<h2 style={{ textAlign: "center" }}>Quiz Question Form</h2>
			<br />
			<h4>
				Upload CSV in this format:{" "}
				<button className="btn btn-primary btn-sm">
					Download Dummy CSV
				</button>
			</h4>
			<img
				src={QuestionCSV}
				style={{ height: "200px", width: "100%" }}
				alt="csv_data"
			/>
			<h4>Separate answers array using ~,~ symbol</h4>
			<p>Eg. [a~,~b~,~c~,~d]</p>
			<br />
			<br />
			<CSVReader
				ref={buttonRef}
				onFileLoad={handleOnFileLoad}
				onError={handleOnError}
				noClick
				noDrag
				// onRemoveFile={handleOnRemoveFile}
			>
				{({ file }: any) => (
					<aside
						style={{
							display: "flex",
							flexDirection: "row",
							marginBottom: 10,
						}}
					>
						<button
							type="button"
							onClick={handleOpenDialog}
							style={{
								borderRadius: 0,
								marginLeft: 0,
								marginRight: 0,
								width: "40%",
								paddingLeft: 0,
								paddingRight: 0,
								display: "block",
							}}
						>
							Browse file
						</button>
						<div
							style={{
								borderWidth: 1,
								borderStyle: "solid",
								borderColor: "#ccc",
								height: 45,
								lineHeight: 2.5,
								marginTop: 5,
								marginBottom: 5,
								paddingLeft: 13,
								paddingTop: 3,
								width: "60%",
							}}
						>
							{file && file.name}
						</div>
						<button
							style={{
								// borderRadius: 0,
								marginLeft: 0,
								marginRight: 0,
								paddingLeft: 20,
								paddingRight: 20,
							}}
							className="btn btn-sm btn-danger"
							onClick={handleRemoveFile}
						>
							Remove
						</button>
					</aside>
				)}
			</CSVReader>
			<button
				className={"btn btn-md btn-warning"}
				onClick={() => InterMediateAddQuestion()}
			>
				Add Questions
			</button>
			<button
				className={`btn btn-md btn-${
					csvData.length <= 1 ? "secondary" : "warning"
				} ml-4`}
				onClick={() => {}}
				disabled={csvData.length <= 1}
			>
				<CSVLink
					data={csvData}
					separator={","}
					filename="questions-with-errors.csv"
				>
					Download CSV errors
				</CSVLink>
			</button>
			<br />
			<br />
			<div>
				<label htmlFor="question">Question:</label>{" "}
				{/* <form className="m-5 p-5" onSubmit={(e)=>submitHandler(e)}> */}
				<textarea
					type="text"
					className="form-control"
					onChange={(e) => setquestion(e.target.value)}
					id="question"
					placeholder="Question"
				/>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="questiontype">Question Type:</label>{" "}
				<textarea
					type="text"
					placeholder="Question Type"
					className="form-control"
					onChange={(e) => setquestiontype(e.target.value)}
					id="questiontype"
				/>
			</div>
			<br />
			<br />
			<div></div>
			<label htmlFor="ques_image">Question Pic:</label>{" "}
			<input
				type="file"
				placeholder="Upload an image"
				className="form-control"
				onChange={(e) => {
					if (!e.target.files[0])
						alert("Select at least one file to be uploaded");
					setQuesImage(e.target.files[0]);
				}}
				id="ques_image"
				name="ques_image"
			/>
			<button
				onClick={() => {
					QuestionImageUploadHandler();
				}}
				className="btn btn-dark"
			>
				Upload
			</button>
			<br />
			<br />
			<div>
				<label htmlFor="AnswerSelectionType">
					Answer Selection Type:
				</label>{" "}
				<select
					placeholder="AnswerSelection Type"
					className="dropdown btn btn-dark"
					onChange={(e) => setanswerselectiontype(e.target.value)}
					id="AnswerSelectionType"
				>
					<option value="null">Choose One</option>
					<option value="single choice">Single Choice</option>
					<option value="multiple choice">Multiple Choice</option>
				</select>
			</div>
			<br />
			<br />
			<div>
				<button
					className="btn btn-primary"
					onClick={() => {
						setIsImageAns(!isImageAns);
						setIsTextAns(false);
					}}
				>
					Upload Ans as Image?
				</button>
				<button
					className="btn btn-primary"
					onClick={() => {
						setIsTextAns(!isTextAns);
						setIsImageAns(false);
					}}
				>
					Upload Ans as Text?
				</button>
			</div>
			{isImageAns ? (
				<div>
					<label htmlFor="ans_image">Answers as Pictures</label>
					<input
						type="file"
						multiple
						placeholder="Choose Multiple Images"
						className="form-control"
						onChange={(e) => {
							setAnsImage(e.target.files);
						}}
						id="ans_image"
						name="ans_image"
					/>
					<button
						onClick={() => {
							ImageUploadHandler();
						}}
						className="btn btn-dark"
					>
						Upload
					</button>
					{uploaded
						? uploadedImages.map((item, index) => {
								return (
									<>
										<table class="table table-striped">
											<tbody>
												<tr>
													<th className="text-dark">
														{++index}
													</th>
													<td>{item}</td>
												</tr>
											</tbody>
										</table>
									</>
								);
						  })
						: null}
				</div>
			) : null}
			{isTextAns ? (
				<div>
					<label htmlFor="ansArr">
						Answer Array:(Add answer and cllick save, keep last
						input field as blank)
					</label>
					<br />
					<br />
					<p>Answer:</p>
					{ansArr.map((inputField, index) => (
						<div key={inputField.id}>
							<textarea
								name="AnswerArray"
								placeholder="Answer Array"
								className="form-control"
								id="ansArr"
								onChange={(event) =>
									setansArr((prev) => {
										const prev_clone = [...prev];
										prev_clone[index] = event.target.value;

										return prev_clone;
									})
								}
							/>
							&emsp;
						</div>
					))}

					<div className="flex gap-4">
						<button
							className="btn btn-sm btn-success"
							onClick={handleAddFields}
						>
							Add
						</button>

						<button
							className="btn btn-sm btn-danger"
							onClick={handleRemoveFields}
							disabled={ansArr.length <= 1}
						>
							Remove
						</button>
					</div>
					<br />
				</div>
			) : null}
			<br />
			<div>
				<label htmlFor="correctanswer">Correct Answer:</label>
				<select
					name="correctanswer"
					id="correctanswer"
					onChange={(e) => setcorrectanswer(e.target.value)}
					value={correctAnswer}
					className="w-full border border-black"
				>
					{!isImageAns &&
						ansArr.map((val) => <option value={val}>{val}</option>)}

					{isImageAns &&
						uploadedImages.map((val) => (
							<option value={val}>{val}</option>
						))}
				</select>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="msgforcorrectans">
					Message For Correct Answer:
				</label>
				<textarea
					type="text"
					placeholder="Message For Correct Answer"
					className="form-control"
					onChange={(e) => setmsgforcorrectans(e.target.value)}
					id="msgforcorrectans"
				/>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="msgforincorrectans">
					Message For Incorrect Answer:
				</label>
				<input
					type="text"
					placeholder="Message For Incorrect Answer"
					className="form-control"
					onChange={(e) => setmsgforincorrectans(e.target.value)}
					id="msgforincorrectans"
				/>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="explanation">Explanation:</label>{" "}
				<input
					type="text"
					placeholder="Explanation"
					className="form-control"
					onChange={(e) => setexplanation(e.target.value)}
					id="explanation"
				/>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="point">Point:</label>{" "}
				<input
					type="text"
					placeholder="Point"
					className="form-control"
					onChange={(e) => setpoint(e.target.value)}
					id="point"
				/>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="timer">Timer:</label>{" "}
				<input
					type="text"
					placeholder="Timer"
					className="form-control"
					onChange={(e) => settimer(e.target.value)}
					id="timer"
				/>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="submitted_no">Submitted No:</label>{" "}
				<input
					type="text"
					placeholder="Submitted No"
					className="form-control"
					onChange={(e) => setsubmitted_no(e.target.value)}
					id="submitted_no"
					required
				/>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="company">Company:</label>{" "}
				<input
					type="text"
					placeholder="Company"
					className="form-control"
					onChange={(e) => setcompany(e.target.value)}
					id="company"
					required
				/>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="avgtosolve">Avg to solve:</label>{" "}
				<input
					type="text"
					placeholder="Avg to solve"
					className="form-control"
					onChange={(e) => setavgtosolve(e.target.value)}
					id="avgtosolve"
				/>
			</div>
			<br />
			<br />
			<div>
				<label htmlFor="topic">Topic:</label>
				<input
					type="text"
					placeholder="Topic"
					className="form-control"
					value={topic}
					onChange={(e) => settopic(e.target.value)}
					id="topic"
				/>
			</div>
			<br />
			<br />
			<button
				className="btn btn-lg btn-primary"
				onClick={() => submitHandler()}
			>
				Submit
			</button>
			{/* </form> */}
		</div>
	);
};

export default QuizQuestionForm;
